import { ProductTileModel, theme } from '@notino/react-styleguide';

const availableTagsForShadesDrawer = [
  ProductTileModel.TagAttributes.Damaged,
  ProductTileModel.TagAttributes.Returned,
];

export const isAvailableTagForShadesDrawer = (
  tag: ProductTileModel.TagAttributes
) => {
  return availableTagsForShadesDrawer.includes(tag);
};

/**
 * Resolves color for item
 * @param item
 * @return color for color circle
 */
export const getItemColors = (item: {
  colors: Array<string>;
}): Array<string> => {
  if (item?.colors?.length > 0) {
    return item.colors;
  }
  return [theme.color.background.primary];
};
